//Generated File 
export default class CommonFieldIds{
	static readonly ACTUAL_CODE = `actualCode`;
	static readonly ALIASES = `aliases`;
	static readonly ALT_CODE = `altCode`;
	static readonly ANALYSISSET = `analysisSet`;
	static readonly APCASE_ID = `apcase.id`;
	static readonly APCASE_SUMMARY = `apcase.summary`;
	static readonly APPROVED_ELEMENT_ENTITY_TYPE = `approvedElement.entityType`;
	static readonly APPROVED_ELEMENT_ID = `approvedElement.id`;
	static readonly Accounting_Module_Name = `accounting`;
	static readonly Adress_Region = `contactInfo.address.region`;
	static readonly BOOK = `book`;
	static readonly BRANCH = `branch`;
	static readonly Basic_Module_Name = `basic`;
	static readonly CODE = `code`;
	static readonly COLOR_CODE = `colorCode`;
	static readonly COMMITE_BEFORE = `commitedBefore`;
	static readonly CONFIG_ENTRY_VALUE = `value`;
	static readonly CREATION_DATE = `creationDate`;
	static readonly CURRENT_APPROVAL_CASE = `currentApprovalCase`;
	static readonly CURRENT_VERSION = `currentVersion`;
	static readonly CUSTOM_VIEW_NAME = `customViewName`;
	static readonly DEPARTMENT = `department`;
	static readonly DESCRIPTOR1 = `descriptor1`;
	static readonly DESCRIPTOR2 = `descriptor2`;
	static readonly DOCUMENT_CODE = `documentCode`;
	static readonly DOCUMENT_FILE_STATUS = `documentFileStatus`;
	static readonly DRAFT_CREATED = `draftCreated`;
	static readonly DocCategory = `docCategory`;
	static readonly EMPLOYEE = `employee`;
	static readonly ENTITY_TYPE = `entityType`;
	static readonly ENTITY_TYPE_CAPITAL_E = `EntityType`;
	static readonly EXTRA_DATA = `extraData`;
	static readonly FIRST_AUTHOR = `firstAuthor`;
	static readonly FISCAL_PERIOD = `fiscalPeriod`;
	static readonly FISCAL_YEAR = `fiscalYear`;
	static readonly FROMDOC = `fromDoc`;
	static readonly FULL_HIERARCHY_PATH = `fullHierarchyPath`;
	static readonly GENERATION_TYPE = `generationType`;
	static readonly GROUP = `group`;
	static readonly HIERARCHY_PATH = `hierarchyPath`;
	static readonly ID = `id`;
	static readonly ID_CAPITAL_I = `Id`;
	static readonly ISSUE_DATE = `issueDate`;
	static readonly LEGAL_ENTITY = `legalEntity`;
	static readonly LINE_CURRENCY_ID = `lines.debit.value.currency`;
	static readonly LINE_RATE_ID = `lines.debit.rate`;
	static readonly LIST_VIEW_CRITERIA = `listViewCriteria`;
	static readonly LIST_VIEW_PAGE_IDS = `listViewPageIds`;
	static readonly LIST_VIEW_SELECTED_IDS = `listViewSelectedIds`;
	static readonly MAIN_FILE = `mainFile`;
	static readonly MASTER_ROW_ID = `masterRowId`;
	static readonly NAME = `name`;
	static readonly NAME1 = `name1`;
	static readonly NAME2 = `name2`;
	static readonly OPEN_SHIFT = `openShift`;
	static readonly PARENT = `parent`;
	static readonly PREVENT_USAGE = `preventUsage`;
	static readonly PREVENT_USE_AS_FROMDOC = `preventUseAsFromDoc`;
	static readonly PURGED = `purged`;
	static readonly REF1 = `ref1`;
	static readonly REF2 = `ref2`;
	static readonly REF3 = `ref3`;
	static readonly REF4 = `ref4`;
	static readonly REF5 = `ref5`;
	static readonly REFERENCE = `reference`;
	static readonly REMARKS = `remarks`;
	static readonly REQUESTS = `requests`;
	static readonly REVISED = `revised`;
	static readonly REVISELEVEL = `reviseLevel`;
	static readonly SECTOR = `sector`;
	static readonly SLAVE_ROWS = `$slaveRows$`;
	static readonly SystemGeneratedCodePrefix = `systemGeneratedCodePrefix`;
	static readonly TERM = `term`;
	static readonly TERM_CONFIG = `termConfig`;
	static readonly TERM_CONFIG_DOT = `termConfig.`;
	static readonly TRANS_ID = `transId`;
	static readonly TRANS_TYPE = `transType`;
	static readonly UPDATE_CAPABILITY = `updateCapability`;
	static readonly USAGE_CAPABILITY = `usageCapability`;
	static readonly VALUE_DATE = `valueDate`;
	static readonly VIEW_CAPABILITY = `viewCapability`;
	static readonly dot_id = `.id`;
}
